export class JuridicaPep {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            pep: {
                value: null,
                header: 'Es el Representante Legal o algún Socio/Accionista un PEP?',
                headerPorTipo: {
                    FRM_TOYOTA: '¿ES EL REPRESENTANTE LEGAL, DIRECTIVO O ALGÚN ACCIONISTA/FIDEICOMITENTE/FIDUCIARIO/BENEFICIARIO/CONSTITUYENTE UN PEP?',
                    FRM_DIFARE: '¿ES EL REPRESENTANTE LEGAL, DIRECTIVO O ALGÚN SOCIO/ACCIONISTA/FIDEICOMITENTE/FIDUCIARIO/BENEFICIARIO/CONSTITUYENTE UN PEP?',
                },
                required: 'Indicar si es Pep'
            },
            nombre_pep: {
                value: '',
                header: 'Nombre del PEP',
                required: 'Nombre del Pep es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            cargo_pep: {
                value: '',
                header: 'Cargo',
                headerPorTipo: {
                    FRM_TOYOTA: 'Cargo:',
                    FRM_DIFARE: 'Cargo:',
                },
                required: 'Cargo es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            institucion_trabaja_pep: {
                value: '',
                header: 'Institución donde trabaja o trabajó',
                headerPorTipo: {
                    FRM_TOYOTA: 'Institución donde trabaja o trabajó:',
                    FRM_DIFARE: 'Institución donde trabaja o trabajó:',
                },
                required: 'Institución es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            fecha_nombramiento_pep: {
                value: null,
                header: 'Fecha del nombramiento de la designación (día/mes/año):',
                required: 'Fecha es requerido'
            },
            fecha_dejo_pep: {
                value: null,
                header: 'Fecha en que dejó de ser PEP, de no estar en funciones (día/mes/año):',
                required: false
            },
            relacion_pep: {
                value: null,
                required: 'Por favor seleccione',
                header: 'El Representante Legal o algún Socio/Accionista/Directivo está relacionado con un PEP:',
                headerPorTipo: {
                    FRM_TOYOTA: '¿EL REPRESENTANTE LEGAL, DIRECTIVO O ALGÚN ACCIONISTA/FIDEICOMITENTE/FIDUCIARIO/BENEFICIARIO/CONSTITUYENTE ESTÁ RELACIONADO CON UN PEP?',
                    FRM_DIFARE: '¿EL REPRESENTANTE LEGAL, DIRECTIVO O ALGÚN SOCIO/ACCIONISTA/FIDEICOMITENTE/FIDUCIARIO/BENEFICIARIO/CONSTITUYENTE ESTÁ RELACIONADO CON UN PEP?',
                },
            },
            relacion_vinculo_pep: {
                value: '',
                header: 'Relación o vínculo:',
                required: 'Relación es requerida',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            nombre_vinculo_pep: {
                value: '',
                header: 'Nombre del PEP:',
                required: 'Nombres es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            cargo_vinculo_pep: {
                value: '',
                header: 'Cargo:',
                required: 'Cargo es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            institucion_vinculo_pep: {
                value: '',
                header: 'Institución donde trabaja o trabajó:',
                required: 'Institución es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            fecha_vinculo_pep: {
                value: new Date(),
                header: 'Fecha del nombramiento:',
                required: 'Fecha es requerido'
            },
            fecha_culminacion_pep: {
                value: null,
                header: 'Fecha de culminación:',
                required: false
            }
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
    strPep = <><b>PEP</b>: Son todas aquellas personas naturales, nacionales o extranjeras, que desempeñan o han desempeñado funciones o cargos públicas destacados en el Ecuador o en el Extranjero; o
        funciones prominentes en una organización internacional, conforme a los lineamentos establecidos por la Unidad de Análisis Financiero y Económico (UAFE), y el organismo de control
        respectivo. <br /><b>FAMILIARES O RELACIONADOS</b>: Son las relaciones comerciales o contractuales que involucren al cónyuge o a las personas unidas bajo el régimen legal de unión de hecho
        reconocida legalmente; o a familiares comprendidos hasta el segundo grado de consanguinidad o primero de afinidad; y, el o los colaborador (es) directo (s) esto es la (s) persona (s)
        natural (es) con las cuales una Persona Expuesta Políticamente (PEP). se encuentre asociada o vinculada societariamente, o mantenga otro tipo de relaciones empresariales, comerciales
        o laborales estrechas, serán consideradas como PEP.</>;
}
